<template>
    <CicPopup
        v-if="showSelect && !$store.showLoadingOverlay"
        :title="$t('Whisper Prompts')"
        :saveable="!!promptId"
        @blur="close"
        @input="$emit('input', listId, promptId)"
    >
        <ul class="item-form">
            <li class="form-label-first">{{ $t('Media List') }}</li>
            <li>
                <CicSelect
                    :value="listId"
                    :options="lists[`_${orgId}`].map((x) => ({ value: x.mediaListId, label: x.name }))"
                    @input="selectList"
                />
            </li>
            <template v-if="listId">
                <li class="form-label">{{ $t('Whisper Prompt') }}</li>
                <li>
                    <CicSelect
                        :value="promptId"
                        :options="prompts.map((x) => ({ value: x.id, label: x.name }))"
                        @input="(val) => (promptId = val)"
                    />
                </li>
            </template>
        </ul>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicSelect from '@/components/inputs/CicSelect';
    import { load } from '@/utils/Http';

    export default {
        name: 'WhisperSelect',
        components: {
            CicSelect,
            CicPopup,
        },
        props: {
            orgId: {
                type: Number,
                required: true,
            },
        },
        emits: ['blur', 'input'],
        data() {
            return {
                listId: null,
                lists: null,
                promptId: null,
                prompts: [],
                showSelect: false,
            };
        },
        watch: {
            orgId() {
                this.loadLists();
            },
        },
        methods: {
            close() {
                this.showSelect = false;
                this.$emit('blur');
            },
            loadLists() {
                this.listId = null;
                this.promptId = null;
                if (this.orgId === 0) {
                    this.showSelect = false;
                } else if (this.lists === null || !this.lists[`_${this.orgId}`]) {
                    this.lists = {};
                    load('medialists/get', { orgId: this.orgId }, (response) => {
                        this.lists[`_${this.orgId}`] = response.lists;
                        this.showSelect = true;
                    });
                } else {
                    this.showSelect = true;
                }
            },
            selectList(val) {
                this.listId = val;
                this.promptId = null;
                const list = this.lists[`_${this.orgId}`].find((x) => x.mediaListId === val);
                if (list.prompts.length > 0) {
                    this.prompts = list.prompts;
                } else {
                    load('prompts/get', { orgId: this.orgId, mediaListId: val }, (response) => {
                        list.prompts = response.prompts;
                        this.prompts = response.prompts;
                    });
                }
            },
        },
    };
</script>
